module.exports = __webpack_public_path__ + "img/max.1ebb6473.svg";